import {createSelector} from "reselect";
import {getDevices} from "../deviceSelector";
import DevTypes from "@wesstron/utils/Api/constants/devTypes";
import {memoize} from "lodash";
import {getEmployeeForSelectList} from "../userSelector";
import {getPlacementArray} from "../../utils/DeviceLocationUtils";
import {getBuildingsMap} from "../buildingsSelector";
import {filterMap} from "../../utils/Utils";

const getShadows = (state) => state.shadows.shadows;

const employeeSelector = createSelector(
    [getEmployeeForSelectList],
    (employees) => {
        return {
            findById: memoize((id) => {
                if (!id) return null;
                return employees.find((e) => e.value === id)?.name ?? id;
            }),
        };
    }
);

/**
 *
 * @param device
 * @param shadow
 * @return {{streamId: string, streamName, isStreamLive: boolean, isCameraOnline: boolean, viewerCount: number, viewers: string[], device: object}}
 */
export const normalizeStreamObject = ({device, shadow}) => {
    const viewers = Object.keys(shadow?.streamData?.viewers ?? {});
    return {
        streamId: device.DevID,
        gatewayId: device.ParentID,
        streamUrl: device?.Settings?.StreamURL,
        streamName: device.Name,
        isStreamLive: !!shadow?.streamObject,
        isCameraOnline: !!shadow,
        viewerCount: viewers.length,
        viewers: viewers,
        device,
    };
};

export const getCameraSelector = createSelector(
    [getBuildingsMap, getDevices, getShadows, employeeSelector],
    (_buildingsMap, _devices, _shadows, _employee) => {
        return filterMap(_devices, (device) => {
            if (device.DevType !== DevTypes.CAMERA) {
                return null;
            }
            const shadow = _shadows.get(device.DevID);
            const placements = getPlacementArray(device)
                .map((PlcmntID) => _buildingsMap.get(PlcmntID))
                .filter((o) => !!o);
            return {
                ...normalizeStreamObject({device, shadow}),
                locationName: placements
                    .map((o) => [o.name.at(-2), o.name.at(-1)].join("-"))
                    .join(", "),
            };
        });
    }
);

export const hasCameraOnFarm = createSelector([getDevices], (devices) => {
    return devices.some((device) => device.DevType === DevTypes.CAMERA);
});
